var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenderwhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.57 19.0591H91.3938V25.3214H100.787V94.207H13.1147V25.3214H22.5082V19.0591H12.3319C11.6 19.0713 10.8776 19.2276 10.2061 19.5191C9.53452 19.8105 8.92698 20.2314 8.41814 20.7577C7.9093 21.284 7.50912 21.9054 7.24046 22.5863C6.9718 23.2673 6.83993 23.9945 6.85237 24.7265V94.8019C6.83993 95.5339 6.9718 96.2611 7.24046 96.9421C7.50912 97.623 7.9093 98.2444 8.41814 98.7707C8.92698 99.297 9.53452 99.7179 10.2061 100.009C10.8776 100.301 11.6 100.457 12.3319 100.469H101.57C102.302 100.457 103.024 100.301 103.696 100.009C104.367 99.7179 104.975 99.297 105.484 98.7707C105.993 98.2444 106.393 97.623 106.661 96.9421C106.93 96.2611 107.062 95.5339 107.05 94.8019V24.7265C107.062 23.9945 106.93 23.2673 106.661 22.5863C106.393 21.9054 105.993 21.284 105.484 20.7577C104.975 20.2314 104.367 19.8105 103.696 19.5191C103.024 19.2276 102.302 19.0713 101.57 19.0591V19.0591Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6426 44.1099H31.9049V50.3722H25.6426V44.1099Z",
    fill: "#ECECEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4336 44.1099H50.6959V50.3722H44.4336V44.1099Z",
    fill: "#ECECEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2178 44.1099H69.4801V50.3722H63.2178V44.1099Z",
    fill: "#ECECEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0039 44.1099H88.2662V50.3722H82.0039V44.1099Z",
    fill: "#ECECEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6426 59.7632H31.9049V66.0255H25.6426V59.7632Z",
    fill: "#ECECEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4336 59.7632H50.6959V66.0255H44.4336V59.7632Z",
    fill: "#ECECEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2178 59.7632H69.4801V66.0255H63.2178V59.7632Z",
    fill: "#ECECEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0039 59.7632H88.2662V66.0255H82.0039V59.7632Z",
    fill: "#ECECEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6426 75.42H31.9049V81.6823H25.6426V75.42Z",
    fill: "#ECECEC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4336 75.42H50.6959V81.6823H44.4336V75.42Z",
    fill: "#ECECEC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2178 75.42H69.4801V81.6823H63.2178V75.42Z",
    fill: "#ECECEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0039 75.42H88.2662V81.6823H82.0039V75.42Z",
    fill: "#ECECEC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9056 31.5851C32.736 31.5851 33.5324 31.2552 34.1196 30.668C34.7068 30.0808 35.0367 29.2843 35.0367 28.4539V9.66693C35.0367 8.83649 34.7068 8.04007 34.1196 7.45286C33.5324 6.86566 32.736 6.53577 31.9056 6.53577C31.0751 6.53577 30.2787 6.86566 29.6915 7.45286C29.1043 8.04007 28.7744 8.83649 28.7744 9.66693V28.4539C28.7744 29.2843 29.1043 30.0808 29.6915 30.668C30.2787 31.2552 31.0751 31.5851 31.9056 31.5851Z",
    fill: "#ECECEC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0032 31.5851C82.8337 31.5851 83.6301 31.2552 84.2173 30.668C84.8045 30.0808 85.1344 29.2843 85.1344 28.4539V9.66693C85.1344 8.83649 84.8045 8.04007 84.2173 7.45286C83.6301 6.86566 82.8337 6.53577 82.0032 6.53577C81.1728 6.53577 80.3764 6.86566 79.7892 7.45286C79.202 8.04007 78.8721 8.83649 78.8721 9.66693V28.4539C78.8721 29.2843 79.202 30.0808 79.7892 30.668C80.3764 31.2552 81.1728 31.5851 82.0032 31.5851Z",
    fill: "#ECECEC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2959 19.0591H72.6075V25.3214H41.2959V19.0591Z",
    fill: "#ECECEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderwhite);
export default __webpack_public_path__ + "static/media/calenderwhite.22a06d17b985d751e6b41ec035ca159e.svg";
export { ForwardRef as ReactComponent };